import { useNavigate } from 'react-router-dom';
import { Alert, Button, Group, Modal } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';

interface AuthModalProps {
  opened?: boolean;
  close?: () => void;
  title: string;
  message: string;
  navTo?: string | null;
  state?: Record<string, string> | null;
}

function AuthModal({ opened = true, close = () => {}, title, message, navTo = null, state = null }: AuthModalProps) {
  const navigate = useNavigate();
  const icon = <IconInfoCircle />;

  const closeHandler = () => {
    if (close) close();
    if (navTo) navigate(navTo, { state });
  };

  return (
    <Modal opened={opened} onClose={closeHandler} centered padding="xl">
      <Alert variant="light" color="teal" title={title} icon={icon}>
        {message}
      </Alert>
      <Group justify="flex-end" mt={25}>
        <Button onClick={closeHandler}>OK</Button>
      </Group>
    </Modal>
  );
}

export default AuthModal;
